import React, {useState, useContext } from 'react';
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import FilterForm from "./FilterForm";
import { pages } from "../../../common/constant";
import SchoolListComponent from './SchoolListComponent';
import { FILTER__FORM_FIELDS_GLOBAL } from '../constants';
import AInput from '../../../../manage/common/formFeilds/customInput/AInput';
import { isNumber } from 'views/pages/manage/gateAttendance/constant';
import { isAlphabet } from 'views/pages/manage/gateAttendance/constant';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import ALoader from 'views/pages/manage/common/a-loader';

const SchoolList = ({
  isLoading,
  setIsLoading,
  globalFilter,
  setGlobalFilter,
  setListVisible,
  dropdownData,
  searchHandler,
  filterCount,
  setFilterCount,
  rows,
  rowCount,
  currentPage,
  onChangeHandler,
  getAll = false,
  loader
}) => {


  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["schoolMaster"]["id"]
  );
  const history = useHistory();
  const [userSearchInput, setUserSearchInput] = useState("");
  const init = async () => {
    try {
      setIsLoading(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const searchInputHandler = () => {

  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      applySearchHandler();
    }
  };

  const applyFilterHandler = async (req) => {
    setIsLoading(true)
    await searchHandler(req);
    setIsLoading(false)
  }
  const applySearchHandler = (value = userSearchInput) => {
    const req = {
      id: isNumber(value) ? (value).trim() : "",
      name: isAlphabet(value) ? (value).trim() : "",
    }
    setGlobalFilter((prev) => ({ ...FILTER__FORM_FIELDS_GLOBAL, ['searchValue']: value }));
    searchHandler(req)
  }
  const handleOnUserInput = (value) => {
    setUserSearchInput(value);
    let res = value === "" || value !== globalFilter?.searchValue;
    if (value === "" && value !== globalFilter?.searchValue)
      applySearchHandler(value)
  };


  return (
    <>
      {isLoading && <ALoader position='fixed' />}
      <Card className="mx-2">
        <div className="d-flex justify-content-between my-3 mx-2">
          <div className="d-flex justify-content-between">
            <BackArrow
              className="color-black mr-2 cursor"
              onClick={() => {
                if (!!getAll) {
                  history.push("/admin/schoolMaster")
                }
                else
                  setListVisible(false)
              }}
            />
            <h4 className="color-black">List of schools</h4>
          </div>

          <div className="d-flex justify-content-between">
            <AInput
              style={{ height: "31px", width: "335px" }}
              value={userSearchInput}
              handler={handleOnUserInput}
              crossIcon={true}
              rightSearchIcon={true}
              searchIconClickHandler={() => { applySearchHandler() }}
              onKeyDown={onKeyDownHandler}
              crossHandler={async () => {
                applyFilterHandler({ ...globalFilter, searchValue: '' });
                setGlobalFilter((prev) => ({ ...prev, searchValue: '' }));

              }}
              placeholder={"Search by school name or ID"}
            />

            <APopover
              buttonComponent={(onClick, styles) => (
                <AButton
                  className="tiny-semi-bold color-dark"
                  onClick={onClick}
                  updatedStyle={{
                    minWidth: "61px",
                    ...(filterCount > 0
                      ? {
                        border: "1px solid #00B0F5",
                        color: "#00B0F5",
                      }
                      : styles),
                  }}
                >
                  Filter {filterCount > 0 && <>( {filterCount} )</>}
                </AButton>
              )}
              menuComponent={(closePopup) => (
                <FilterForm
                  closePopup={closePopup}
                  dropdownData={dropdownData}
                  globalFilter={globalFilter}
                  filterCount={filterCount}
                  setFilterCount={setFilterCount}
                  setGlobalFilter={setGlobalFilter}
                  applyFilterHandler={applyFilterHandler}
                />
              )}
            />
            {(userPermissions?.includes("C") || userPermissions?.includes("U")) && <AButton
              variant="primary_filled"
              onClick={() => {
                const url = `${window.location.origin
                  }/#/admin/master/schoolMaster?isView=${false}`;

                window.open(url, "_blank").focus();
              }}
              size="xs"
            >
              + Add school
            </AButton>}
          </div>
        </div>

        <SchoolListComponent
          rows={rows}
          isLoading={isLoading}
          currentPage={currentPage}
          totalRecords={rowCount}
          onChangeHandler={onChangeHandler}
        />

      </Card>
    </>
  );
}

export default SchoolList;